import React, { useEffect, useState, useRef } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import {
	Grid,
	Typography,
	Button,
	IconButton
} from '@material-ui/core';
import axios from 'axios'
import * as Utils from '../../commons/utils/Utils';
import CloseIcon from '@material-ui/icons/Close';
import Config from '../../commons/config/Config.js'
import ConfigBusiness from '../../commons/config/ConfigBusiness.js';
import CircularProgress from '@material-ui/core/CircularProgress';

const configAxios = {
	headers: {
		'Authorization-Token': localStorage.getItem("token")
	}
};

const ReportesView = ({ reporte, onClose, loading}) => {
	const intl = useIntl()
	const [adjuntos, setAdjuntos] = useState([]);
	const [loadingReporte, setLoadingReporte] = useState(false);

	const transportadoraGrilla = ConfigBusiness.get('moviles.transportadora.grilla') === 'true';

	useEffect(() => {
		setLoadingReporte(true);
		Utils.getData(`/safeFeedback/${reporte.id}`)  // Fetch latest data
		.then((data) => {
			setAdjuntos(data.adjuntos);
			setLoadingReporte(false);
		});
	}, [reporte.id]);

	if (!reporte) return null;

	const openImage = (adjunto_id) => {
		let config = Object.assign({}, configAxios, { responseType: 'blob' });
		axios.get(Config.get('apiUrlBase') + '/adjuntos/files/' + adjunto_id, config).then(response => {
			if (response.status === 200) {
				let fileUrl = URL.createObjectURL(response.data);
				window.open(fileUrl)
			}
		}).catch((e) => { console.log(e) });
	}

	return (
		<>
			{/* Header */}
			<Grid container alignItems="center" justifyContent="space-between">
				<Grid item>
					<Grid container alignItems="center" spacing={1}>
						<Grid item>
							<FormattedMessage id="safeFeedback_modalView.render.Reporte" defaultMessage="Reporte" />
						</Grid>
					</Grid>
				</Grid>

				<Grid item>
					<IconButton onClick={onClose}>
						<CloseIcon />
					</IconButton>
				</Grid>
			</Grid>

			{/* Body */}
			<Grid container spacing={2} style={{ marginTop: 16 }}>
				<Grid item xs={6}>
					<Typography><FormattedMessage id="safeFeedback_modalView.render.ID" defaultMessage="ID" /></Typography>
					<Typography><b>#{reporte.id}</b></Typography>
					<br/>
					<Typography><FormattedMessage id="safeFeedback_modalView.render.Conductor" defaultMessage="Conductor" /></Typography>
					<Typography>
						<b>{reporte.conductor || 'No asignado'}</b>
					</Typography>
					<br/>
					<Typography><FormattedMessage id="safeFeedback_modalView.render.Fecha_y_Hora" defaultMessage="Fecha y Hora" /></Typography>
					<Typography><b>{reporte.fecha}</b></Typography>
                    <br/>
					<Typography><FormattedMessage id="safeFeedback_modalView.render.Base" defaultMessage="Base" /></Typography>
					<Typography><b>{reporte.base_descripcion}</b></Typography>
                    <br/>
					<Typography><FormattedMessage id="safeFeedback_modalView.render.Estado" defaultMessage="Estado" /></Typography>
					<Typography><b>{reporte.estado}</b></Typography>

					<br/>
					<Typography
						style={{ marginTop: 16 }}
					>
						<FormattedMessage id="safeFeedback_modalView.render.Adicionales" defaultMessage="Adicionales" />
					</Typography>
					<Typography>
						<b>{reporte.adicionales}</b>
					</Typography>

					<br/>
					<Typography
						style={{ marginTop: 16 }}
					>
						<FormattedMessage id="safeFeedback_modalView.render.Descripción" defaultMessage="Descripción" />
					</Typography>
					<Typography>
						<b>{reporte.descripcion}</b>
					</Typography>

					<br/>
					<Typography
						style={{ marginTop: 16 }}
					>
						<FormattedMessage id="safeFeedback_modalAccion.render.adjuntos" defaultMessage="Adjuntos" />
					</Typography>
					{loadingReporte ? (
						<div style={{ textAlign: 'center', margin: '16px 0' }}>
							<CircularProgress color="primary"/>
						</div>
						) : (
						adjuntos.map((adjunto) => (
							<Typography key={adjunto.id}>
							<b>
								<i
								onClick={() => openImage(adjunto.id)}
								className="cursor-pointer pr-1 fa fa-2x fa-paperclip">
								</i>
							</b>
							</Typography>
						)))
					}
					<br/>
					<Typography
						style={{ marginTop: 16 }}
					>
						<FormattedMessage id="safeFeedback_modalView.render.Comentario" defaultMessage="Comentario" />
					</Typography>
					<Typography>
						<b>{reporte.comentario}</b>
					</Typography>
				</Grid>

				<Grid item xs={6}>
					<Typography><FormattedMessage id="safeFeedback_modalView.render.Vehículo" defaultMessage="Vehículo" /></Typography>
					<Typography><b>{reporte.dominio}</b></Typography>
					<br/>
					<Typography><FormattedMessage id="safeFeedback_modalView.render.Tipo" defaultMessage="Tipo" /></Typography>
					<Typography ><b>{reporte.tipo_relato}</b></Typography>
                    <br/>
					<Typography><FormattedMessage id="safeFeedback_modalView.render.Tipo_de_ocurrencia" defaultMessage="Tipo de ocurrencia" /></Typography>
					<Typography ><b>{reporte.tipo_ocurrencia}</b></Typography>
                    <br/>
					<Typography><FormattedMessage id="safeFeedback_modalView.render.Ocurrencia_Reportada_por" defaultMessage="Ocurrencia Reportada por" /></Typography>
					<Typography ><b>{reporte.reportado_por}</b></Typography>
					{transportadoraGrilla && (
						<>
							<br/>
							<Typography><FormattedMessage id="safeFeedback_modalView.render.Transportadora" defaultMessage="Transportadora" /></Typography>
							<Typography><b>{reporte.transportadora_nombre != null ? reporte.transportadora_nombre : '—'}</b></Typography>
							<br/>
							<Typography><FormattedMessage id="safeFeedback_modalView.render.Centro_de_costos" defaultMessage="Centro de costos" /></Typography>
							<Typography><b>{reporte.centro_costos_nombre != null ? reporte.centro_costos_nombre : '—'}</b></Typography>
						</>
					)}
				</Grid>
			</Grid>

			<Grid
				container
				justifyContent="flex-end"
				spacing={1}
				style={{ marginTop: 24 }}
			>
				<Grid item>
					<Button onClick={onClose}>
						<FormattedMessage id="safeFeedback_modalView.render.Volver" defaultMessage="Volver" />
					</Button>
				</Grid>
			</Grid>
		</>
	);
};

export default ReportesView;
